import React from "react";
import Progressbar from "components/Reusable/Progressbar/Progressbar.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploadingSpeed } from "components/Pages/Home/Helpers/useUploadingSpeed.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const FormsUploaderProgress = ({ filesCount, filesProgress }) => {
  const { uploaderGetFiles, getSize, getUploading } = useUploader();

  const { getTextByKey } = useContent();

  const data = uploaderGetFiles();

  const viewSize = bytesToDisplayHelper(getSize());

  const { estimationTime, progress, getuploadedSize, uploadSpeed } =
    useUploadingSpeed(filesProgress);

  const uploadedSize = bytesToDisplayHelper(getuploadedSize());

  const uploadingString = () => {
    return (
      <>
        {`${getTextByKey("uploading-text")} ${filesCount}/${data.length} `}
        <span>
          {`(${uploadedSize.size} ${uploadedSize.type} / ${viewSize.size} ${viewSize.type})`}
        </span>
      </>
    );
  };

  return (
    <>
      <div className="jm-forms-total-progress-wrapper">
        <div className="total-progress">
          <Progressbar completed={progress} height="4px" />
        </div>
      </div>
      <div className="progress-percentage">{progress}%</div>
      <div className="uploading-info">
        <div className="counter-files-size">
          {getUploading() ? uploadingString() : null}
        </div>
        <div className="estimation-time">
          {estimationTime.length > 0
            ? `${uploadSpeed}/s ${getTextByKey(
                "estimation-time-text"
              )} ${estimationTime}`
            : ""}
        </div>
      </div>
    </>
  );
};

export default FormsUploaderProgress;
